import React from 'react';

import type { Nullable } from '@clearverify/types';

import {
  ConsumerDocument,
  EmployeeUpdate,
  useConsumerQuery,
  useConsumerUpdateMutation,
} from 'src/api';

type ConsumerByIdHookParams = {
  skip?: boolean;
};

export const useConsumerById = (id: Nullable<string>, params: ConsumerByIdHookParams = {}) => {
  const { data, loading } = useConsumerQuery({
    variables: {
      id: String(id),
    },
    skip: !id || params.skip,
  });

  const consumer = React.useMemo(() => data?.employee, [data?.employee]);

  const [consumerUpdateMutation, { loading: updating }] = useConsumerUpdateMutation({
    refetchQueries: [ConsumerDocument],
  });

  const updateConsumer = React.useCallback(
    async (data: EmployeeUpdate) => {
      if (!id) {
        return;
      }

      await consumerUpdateMutation({
        variables: {
          where: { id },
          data,
        },
      });
    },
    [consumerUpdateMutation, id],
  );

  return {
    consumer,
    loading,
    updateConsumer,
    updating,
  };
};
